import React from "react";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";

import Tabs from "app/components/Tabs";

const ModalTabs = ({ classes, value, children }) => (
  <Tabs
    value={value}
    classes={{
      root: classes.root,
    }}
  >
    {children}
  </Tabs>
);

const styles = theme => ({
  root: {
    minHeight: 100,
    maxHeight: 100,
  },
});

export default compose(
  React.memo,
  withStyles(styles),
)(ModalTabs);
